import React, { useEffect, useState } from "react";
import { useGetAllUsersRollCallList } from "../../hooks/useManagement";
import Loading from "../Loadings/LoadingTable";
import { Table } from "../Table/Table";

const RollCallTable = () => {
  const [Search, setSearch] = useState("");
  const { data, isLoading, hasNextPage, fetchNextPage } =
    useGetAllUsersRollCallList({ search: Search });

  useEffect(() => {
    let fetching = false;
    const onScroll = async (event) => {
      const { scrollHeight, scrollTop, clientHeight } =
        event.target.scrollingElement;
      if (!fetching && scrollHeight - scrollTop <= clientHeight * 2.5) {
        fetching = true;
        if (hasNextPage) await fetchNextPage();
        fetching = false;
      }
    };
    document.addEventListener("scroll", onScroll);
    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, [fetchNextPage, hasNextPage]);
  const RollCallHeader = [
    "ردیف",
    "نام و نام خانوادگی",
    "ساعت ورود",
    "ساعت خروج",
    "تاریخ",
    "مرخصی",
    "ماه",
    "کاهش یا افزایش",
  ];
  let i = 0;
  const items = data
    ? data?.pages?.map((page) =>
        page?.data?.data?.map((item, index) => {
          i++;
          return (
            <tr key={index}>
              <td>
                <span className="text-muted fw-bold text-muted d-block fs-7">
                  {i}
                </span>
              </td>
              <td>
                <span className="text-muted fw-bold text-muted d-block fs-7">
                  <span>
                    {(item?.user?.FirstName ? item?.user?.FirstName : "") +
                      " " +
                      (item?.user?.LastName ? item?.user?.LastName : "")}
                  </span>
                </span>
              </td>
              <td>
                <span className="text-muted fw-bold text-muted d-block fs-7">
                  {item?.StartHours}
                </span>
              </td>

              <td>
                <span className="text-muted fw-bold text-muted d-block fs-7">
                  {item?.EndHours}
                </span>
              </td>
              <td>
                <span className="text-muted fw-bold text-muted d-block fs-7">
                  <span
                    className={`text-muted fw-bold text-muted d-block fs-7`}
                  >
                    {item?.DateShamciHours}
                  </span>
                </span>
              </td>

              <td>
                <span className="text-muted fw-bold text-muted d-block fs-7">
                  {item?.Leave === 0 ? "بدون مرخصی" : item?.Leave}
                </span>
              </td>
              <td>
                <span className="text-muted fw-bold text-muted d-block fs-7">
                  {item?.MonthHours}
                </span>
              </td>
              <td>
                <span className="text-muted fw-bold text-muted d-block fs-7">
                  {item?.sum}
                </span>
              </td>
            </tr>
          );
        })
      )
    : "";
  return (
    <Table
      className="mt-3"
      setSearch={setSearch}
      headerTitle={RollCallHeader}
      items={items ? items : <Loading />}
      title={`لیست حضور و غیاب (${i})`}
    />
  );
};

export default RollCallTable;
